<template>


<div>
  <v-snackbar bottom  dark color="green darken-2"  v-model="snackbar.show" :timeout="1000" top>
        {{ snackbar.message }}
    </v-snackbar>
  <loading :active.sync="isLoading" 
        
        :is-full-page="fullPage"></loading>
         <v-container style="padding-top: 0px;" fixed> 
           <v-row> 
             <v-col cols="10" style="padding-right: 0px;">

               <v-select :options="key" v-model="search"  taggable placeholder="Search items new" style="width:100%;"></v-select>
              



               
             </v-col>
              <v-col cols="2" style="padding-left: 0px;">
                <b-button variant="outline-success" style="border-color: #28a74500;" @click="searchItem">  <v-icon>mdi-magnify</v-icon></b-button>
             </v-col>
          
           </v-row>
           <v-row style="display:none;">
              <vue-taggable-select
               
    :taggable="true"
    :max-results="5000"
    :max="1"
    v-model="search" 
    :options="key"
    placeholder="Search items"
    
></vue-taggable-select>
              <v-select :options="keyword" v-model="search" placeholder="Search items" style="width:100%;"></v-select>
           </v-row>
           
  
    
      </v-container>



<v-container class="grey lighten-5"  >
      
    <v-row dense
    >
    
    <v-col
    
          v-for="(item, i) in scrollproducts"
          :key="i"
          cols="6"
        >
       
     <v-card  light style="color:grey" >
       <div id="titl" style="background: #f0f0f0;">
          <b style="font-size: 10px;"
                  class="headline cs"
                > {{item.ItemName}}</b><br>
                <b style="font-size: 10px;"
                  class="headline cs"
               > {{item.ArabicName}}</b>
       </div>
       <div @click="openitem(item.Barcode,item)">
            <v-avatar
                class="ma-3"
                size="125"
                tile
              >
                <v-img :src="imgURL+item.ItemCode+'.jpg'" :id="item.Barcode"  @error="setAltImg(item.Barcode)" :alt="item.ItemCode+'.jpg'" ></v-img>
               
              </v-avatar>
               <v-card-title style="color: #ffc107;"
                  class="headline"
                 
                >₹{{ formatPrice(item.SellingRate) }}</v-card-title>
       </div>
    <v-row no-gutters>
      <v-col cols="4" :id="item.SellingRate"  @click="addwishlist(item.ItemName,i,item.Barcode)" >
        <v-btn icon >
          <v-icon :id="item.Barcode+item.ItemName">mdi-heart</v-icon>
        </v-btn>
      </v-col>
      <v-col class="4" :id="item.SellingRate"  @click="adcart(item.ItemName,i,item.Barcode,item.ArabicName)">
              <v-btn icon  >
                <v-icon :id="item.Barcode+item.ArabicName">mdi-cart</v-icon>
                
              </v-btn>
      </v-col>
    
      <v-col class="4">
              <v-btn icon>
                <v-icon>mdi-share-variant</v-icon>
              </v-btn>
     </v-col>
    </v-row>
     </v-card>
    </v-col>
      
     
         
       
    </v-row>
  </v-container>
 <v-container v-show="hidegif">
  <div style="margin-top:0rem"> 
 
<div class="text-center " style="margin-top:1rem">
   <div><img :src="notfound" style="width: 100%;">
</div>
</div>
</div>
 </v-container>

  </div>
</template>

<script>

import Vue from 'vue'
 import axios from 'axios';
 import Loading from 'vue-loading-overlay';
    // Import stylesheet
 import Router from '../router';
 import 'vue-loading-overlay/dist/vue-loading.css';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import VueTaggableSelect from "vue-taggable-select";
// import VueSingleSelect from "vue-single-select";
// Vue.component('vue-single-select', VueSingleSelect);

Vue.component('v-select', vSelect)
  export default {
    components: {
            Loading, vSelect, VueTaggableSelect///,VueSingleSelect
        },
    data: () => ({
      fruit:'',
      film:'',
      keyword:[],
      search:'',
      imgURL:'',
      isLoading: false,
      fullPage: true,
      scrolledToBottom: 1,
      products : [],
      scrollproducts : [],
      seen :true,
      seenid:'',
      cartlist:[],
      wishlist:[],
      text: '',
      timeout: 1500,
      scrcount : 1,
      colorcount:0,
      hidegif:true,
      cartitem:[],
      wishitem:[],
      test:[],
      firstload:'',
       notfound:"https://cdn.dribbble.com/users/1501052/screenshots/5468049/searching_tickets.gif",
      loopcart:'',
      snackbar: {
                show: false,
                message: null,
                color: null
            },
      clicked: [],
       wishclicked: [],
      cartcolorbar:[],
      items: [
        {
          color: '#1F7087',
          src: 'https://demo.w3layouts.com/demos_new/template_demo/20-07-2017/grocery_store-demo_Free/725976873/web/images/1.png',
          title: 'Fortune Sunflower Oil',
          price: '₹117.99',
          id:'2145'
        },
        {
          color: '#1F7087',
          src: 'https://demo.w3layouts.com/demos_new/template_demo/20-07-2017/grocery_store-demo_Free/725976873/web/images/2.png',
          title: 'Pepsi Soft Drink (2 Ltr)',
          price: '₹60.00',
          id:'2155'
        },
        
        {
         color: '#1F7087',
          src: 'https://demo.w3layouts.com/demos_new/template_demo/20-07-2017/grocery_store-demo_Free/725976873/web/images/3.png',
          title: 'Rice (5kg)',
          price: '₹517.00',
          id:'2165'
        },
        {
          color: '#952175',
          src: 'https://demo.w3layouts.com/demos_new/template_demo/20-07-2017/grocery_store-demo_Free/725976873/web/images/4.png',
          title: 'Dog Food',
          price: '₹231.00',
          id:'2175'
        },
        
      ],
      result:'',
      key : JSON.parse(localStorage.getItem("key"))
// key:["''","&amp;","(84)","(88)","001","002","003/1","003/2","003/3","004/1","004/2","004/3","004/4","005/1","005/2","005/3","005/4","005/5","1.0","1.0ltr","1.5","1.5ltr","1.8","1.8ltr","10","10\"","10%","100","1000","1000g","1000ml","100g","100GM","100ml","100pc","100PCS","100s","10kg","10PC","10pcs","10s","11","12","12\"","120","120g","120ml","120s","125","125g","125ml","12PC","12PCS","12s","13","135g","14","14X23","15","15%","15%off","150","150g","150GM","150ml","16","160g","170g","175g","18","180","180ml","185g","1kg","1ltr","1MTR","1PC","1PCS","1X3","1X5","2.5","2.5kg","20","20%","20%OFF","200","200g","200GM","200ml","200s","20CM","20g","20PC","20S","21","22","220X240","22CM","24","240ml","24cm","24PC","24pcs","24s","24X20g","25","2-5","250","250g","250GM","250ml","25-30","25g","25PC","25s","26cm","28","28cm","2IN1","2kg","2ltr","2PC","2PCS","2ply","2X400g","2X400ml","2X6","3.5","30","300","300g","300GM","300ml","30cm","30g","30PC","30PCS","30s","31-36","31-38","330","330ml","340","340g","350g","350ml","360","36-41","37-41","375","3in1","3kg","3LTR","3PAIR","3PC","3PCS","40","400","400g","400GM","400ml","40-45","40CM","40g","40GM","45","450g","450GM","450ml","45CM","4LTR","4PC","4PCS","4X400g","50","500","500g","500GM","500ml","50g","50GM","50ml","50pc","50pcs","50s","5kg","5ltr","5PAIR","5PC","5PCS","60","600g","600ml","60g","60ml","6PC","6PCS","6X125g","6X9","700g","700ml","70g","750","750g","750ml","75g","75ml","7PC","7PCS","8\"","800g","80g","80s","8PC","900","900g","90g","A/C","A/G","A/Q","A4","AA","ACCESSORIES","ACRYLIC","ACTIVE","ADS","AIN","AIR","AL","ALALI","ALMARAI","ALMOND","ALU","ALU.COOKWARE","ALUM","ALUMINIUM","APPLE","ARABIC","ART","ASSTD","AVCI","B/O","BABY","BABY GARMENTS","BACK","BAG","Bags","BAHAR","BAKERY","BALL","BALLOON","BAMBI","BAMBOO","BANANA","band","BAR","BARMUDA","BASIC","BASKET","BASMATI","BATH","BATTERY","BBQ","BEACH","BEANS","BEAR","BEAUTY","BED","BEEF","BELT","BERMUDA","BEST","BESTART","BIG","BIKE","BIN","BISCUIT","BISCUITS","BLACK","BLANKET","BLENDER","BLK","BLOCK","BLOUSE","BLUE","BOARD","BODY","BOOK","BOTTLE","BOWL","BOX","BOYS","Boys Garments","Boys Shoes","BRA","BREAD","BROOM","BROWN","BRUSH","BS","BTL","BUCKET","BURNER","BUTTER","C/G","C/WARE","CABLE","CADBURY","CAKE","CAN","CAN FOODS","CANDLE","CANDY","CAP","CAPRI","CAR","Car Accessories","CARAMEL","card","CARE","CASE","CASSEROLE","CAWA","CERAMIC","CHAIR","CHARCOAL","CHEESE","CHICKEN","CHILDREN","CHILDRENS","CHILLI","CHILLY","CHINA","CHIPS","CHKN","CHOCO","CHOCOLATE","CLARKS","CLASSIC","CLAY","CLEAN","CLEANER","CLEANING","CLEAR","CLIKON","CLIP","CLIPPER","CLOCK","CLOROX","CLOTH","CLR","CM","COAT","COCKTAIL","COCOA","COCONUT","COFFEE","COLGATE","COLOR","COLOUR","COMFORT","CONCORD","CONTAINER","COOK","COOKER","COOKIES","COOKING","COOKWARE","COOL","CORDOBA","CORN","COSMETIC","COSMETICS","COTTON","COVER","CREAM","CRM","CRYSTAL","CUP","CUTTER","CUTTING","DABUR","DAC","DAILY","DAL","Decoration","DECORE","DEEP","DEO","DETERGENT","DETTOL","DIARY","DINNER","DISH","DISINFECTANT & DETERGENTS","DISPENSER","DOLL","DOOR","DOUBLE","DOVE","DRESS","DRINK","DRINKS","DRY","DRY FRUITS","DRYER","DUST","DUSTBIN","EDP","EDT","EGG","ELECTRIC","Electronics","ELEKTA","ENCHANTEUR","ENERGY","ERASER","EXT","EXTRA","EYE","FA","FACE","FACIAL","FAMILY","FAN","FANCY","FAT","FEEDING","FELAIJ","FILE","FILTER","FINE","FIS","FLAMINGO","FLASK","FLAT","FLOOR","FLOWER","Flowers","FOAM","FOIL","FOOD","FOOD ITEM","FOOD WITH TAX","FOOD WITH VAT","FOODS","FOOT","FOOTBALL","FOOTWARE","FOR","FOSTER","FRAME","FREAM","FREE","FRESH","FRESHNER","FRICTION","FROCK","FROZEN","FRUIT","FRY","FRYPAN","FULL","FUSTAN","GALAXY","GAME","GARDEN","GARLIC","GARMENTS","GARNIER","GAS","GEEPAS","GEL","GIFT","GIRLS","girls garments","Girls Shoes","GLASS","GLOVES","GLUE","GM","GOLD","GOLDEN","GOWN","GREEN","GRILL","GULFAR","GUM","GUN","H/P","HAIR","HAIR COLOR","HAND","HANDLE","HANDWASH&DISHWASH","HANGER","HAPPY","HARDWARE","HATAM","HEAD","HEAVY","HEEL","HENNA","HERBAL","HERSHEYS","HIMALAYA","HOLD","HOLDER","HOME","HONEY","HOOK","HOT","HOTPOT","HOUSE","HOUSE HOLD","HouseHold","HZLNT","ICE","IN","INFANT","INTEX","IRAN","IRON","ITEM","JACKET","JAM","JAR","JEANS","JELLY","JEWELARY","JOHNSONS","JS","JUG","JUICE","JUMBO","KADAI","KADRIS","kawashi","KETCHUP","KETTLE","KEY","kg","KIDS","Kids Section","KIDS SHOES","KING","KIT","KITCHEN","KNIFE","LA","LABAN","LACNOR","LADIES","Ladies Garments","Ladies Shoes","LADY","LAMP","LARGE","laser","LCHEAR","LED","LEGEND","LEGGING","LEMON","LID","LIFEBUOY","LIGHT","LIGHTER","LINER","LINGERIES","LIP","LIPTON","LIQ","LIQUID","LOCK","LONG","LOREAL","LOTION","LOVE","LOW","LTR","LUNCH","LUNGI","LUX","MACARONI","MACHINE","MAGGI","MAGIC","MAKE","MAKER","MAN SHOES","MANGO","MANTO","MARKER","MASALA","MASK","MAT","MAX","MAXI","MAYONNAISE","MEAT","MED","MEDIUM","MEHRAN","MELAMINE","MEN","Men Garments","MENS","MESCO","METAL","MILK","MILK & DIARY PRODUCT","MINI","MINT","MIRROR","MISS","MIX","MIX SHOES","MIXED","MIXER","ml","MM","MODEL","MOP","MOULD","MTR","MUG","MULTI","MUSIC","M-XXL","NABIL","NAIL","NATIONAL DAY ITEM","NATURAL","NESTLE","NET","NEW","NIGHT","NIGHTY","NIVEA","NO:","NOTE","NOTEBOOK","OFF","OFFER","OIL","OLIVE","OLIVES","OLSENMARK","OMAN","ON","ORANGE","ORIGINAL","OTHER","OUD","OVAL","OVEN","PACK","PACKERS","PAD","PAMPERS","PAN","PANASONIC","PANT","PANTS","PANTY","PAPER","PARFUM","PARTY","PASTE","PAYJAMA","PC","PCS","PEANUT","PEAS","PEN","PENCIL","PERFUME","PHOTO","PICKLE","PIGEON","PILLOW","PIN","PINEAPPLE","PINK","PIPE","PK","PKT","PLAIN","PLASTIC","PLASTIC ITEM","plastic items","PLASTICITEM","PLATE","PLAY","PLUS","POLISH","POT","POWDER","POWER","PRAN","PRESIDENT","PSI","PUCK","PUFF","PUMP","PURE","PVC","PWDR","QURAN","R/C","RACK","RANI","RED","REGAL","REMOVER","REXONA","RIBBON","rice","RING","ROLL","ROMPER","ROPE","ROSE","ROUND","ROYAL","RS","RUBBER","S/S","SADIA","SALT","SAND","SANDAL","SANFORD","SANITA","SAUCE","SAUCER","SCALE","SCARF","SCHOOL","SCISSORS","SCRUB","SEED","SEMILONG","SET","SHAAB","SHAHI","SHAMPOO","SHARPNER","SHEET","SHELA","SHELHA","SHIRT","SHMP","SHOE","SHOES","SHORT","SHOWER","SILVER","SINGLE","SKIN","SKIRT","SLIP","SLIPPER","SLIPPERS","SMALL","SNACKS","SOAP","SOCKET","SOCKS","SOFT","SOUP","SP","speaker","SPICE","SPL","SPONGE","SPOON","SPORT","SPORTS","SPRAY","SPRING","SQUARE","SS","STAND","STAR","Stationary","STEEL","STICK","STICKER","STONE","STORAGE","STOVE","STRAINER","STRAWBERRY","SUGAR","SUIT","SUN","SUNBULAH","SUNSILK","SUPER","SWEATER","SWEET","SWEETS","SYOSS","T/B","T/CASE","T/P","TABLE","TAPE","TAWA","TAYAS","TEA","TEA & COFFEE","Tiessues","TIMMY","TIN","TISSUES","TOILET","TOKYOSAT","TOMATO","TOOL","TOOTH","TOOTH PASTE & TOOTH BRUSH","TOP","TOPE","TORCH","TOUCH","TOWEL","TOY","TOYS","TRACK","TRAMONTINA","TRASH","TRAY","TRIMMER","TRISA","TROLLEY","TROLLY","TROUSER","TRUCK","T-SHIRT","TUMBLER","TUNA","ULKER","UNDERWEAR","UNIKAI","UP","USHAS","VACUUM","VANILLA","VASE","VASELINE","VATIKA","VEGETABLE","VELVET","VEST","VEZAR","W/LID","W/غطاء","WAFER","WALKER","WALL","WALLET","WARE","WASH","WATER","WAX","WHITE","WIPER","WIPES","WITH","WOOD","WOODEN","YARDLEY","YELLOW","YOGHURT","YOUTH","Y-PLUS","إبريق","أداه","أدوات","أرز","أسنان","أطفال","أفضل","ألعاب","ألومنيوم","إلى","إناء","أنبوب","أولاد","ابيض","احذيه","احمر","اخضر","اسود","اطار","اكسترا","الأبيض","الأحمر","الأخضر","الأرز","الأزرق","الإسفنج","الأسنان","الأسود","الأصلي","الإطار","الأطفال","الأظافر","الإعلانات","الأعلى","الأكريليك","الأناناس","الأولاد","الاجهزه","الاحتكاك","الاحذيه","الاشتراكية","الانسجه","البحر","البدلة","البرتقال","البسكويت","البلاستيك","البلاستيكية","البنات","البند","البيض","البيضاوي","التجميل","التحتي","التخزين","التفاح","التونة","الجدار","الجدول","الجسم","الجلد","الجمال","الجوارب","الجينز","الحائط","الحار","الحديد","الحلاقة","الحلو","الحلوى","الحليب","الحمام","الحناء","الخاص","الخبز","الخزف","الخشب","الخفيفة","الخيزران","الدب","الدجاج","الدسم","الديكور","الذرة","الذهب","الذهبي","الرئيس","الربيع","الرجال","الرجالية","الرجل","الرف","الرياضة","الزجاج","الزيتون","السائل","الساخن","الساخنة","السكر","السلطانية","السلطة","السوداني","السيارات","السيدات","السيراميك","الشاطئ","الشاي","الشب","الشباب","الشريط","الشعر","الشعلة","الشفاه","الشمس","الشوكولاتة","الصابون","الصدر","الصدرية","الصغيرة","الصلب","الصمام","الصورة","الطازج","الطازجة","الطاقة","الطبخ","الطبيعي","الطفل","العربية","العرض","العسل","العلالي","العناية","العين","الغاز","الغبار","الغداء","الغذاء","الغراء","الغسيل","الفاكهة","الفانيليا","الفتات","الفتيات","الفتيان","الفحم","الفراولة","الفرقة","الفلفل","الفول","القدح","القدم","القران","القصدير","القطن","القلم","القماش","القميص","القهوة","الكاكاو","الكبير","الكتاب","الكره","الكلمة","اللباس","اللعب","اللوحة","اللوز","اللون","الليمون","الماء","المانجو","المتوسطة","المجلس","المراعي","المسار","المطابخ","المطبخ","المعدنية","المكياج","الملابس","الملك","المهملات","الموز","المياه","الميلامين","النعال","النفط","النقي","اله","الهند","الهواء","الو","الوجه","الوردي","الوقوف","اليد","اليدين","انتكس","اورانج","اولسينمارك","اير","ايس","باب","بار","بارد","باك","بالون","بامبرز","بامبي","باناسونيك","بانت","باند","بخاخ","بدله","براون","برمودا","بسكويت","بطاقة","بطانية","بلاستيك","بلاستيكية","بلايت","بلس","بلسم","بلوزه","بلوك","بن","بنات","بندقية","بنطال","بنطلون","بنين","بهلوان","بودرة","بوك","بوكس","بوي","بي","بيبي","بيجاما","تجهيزات","ترافونتينا","تروللي","ترولي","تنظيف","تنوره","توب","تي","تيشيرت","تيمي","ثوب","جامبو","جبنه","جديد","جرام","جره","جل","جمهوريه","جوارب","جوز","جولة","جونسون","جيباس","جيم","جينز","جيويلاري","حائط","حار","حاله","حامل","حبل","حزام","حزب","حزمه","حساء","حصيره","حقيبة","حلاقه","حلوي","حليب","حمام","حمامه","حوض","خشبي","خشبيه","خصم","خلاط","دبوس","دثار","دجاج","درج","دعوى","دلو","دميه","دوف","دوڤ","ديتول","ديو","رئيس","راني","رجالي","رجالية","رجل","رذاذ","رصاص","رغوة","رف","رقائق","رقم","رقم:","روز","رول","رومبير","رويال","رياضيه","زبده","زجاج","زجاجه","زجاجي","زلة","زهره","زهريه","زيت","زيتون","ساديا","ساعة","سانفورد","سانيتا","ستار","ستره","سرير","سكين","سلسله","سله","سم","سوبر","سيارة","سيراميك","سيكون","شاحنه","شارتنر","شامبو","شاهي","شاي","شباشب","شبشب","شرائح","شراب","شماعات","شمعه","شوربة","شوكو","شوكولاتة","شيبس","شيرت","شيله","صابون","صافي","صانع","صحن","صغير","صغيره","صلصة","صندل","صندوق","صوص","صينية","ضوء","طاوله","طباخ","طبق","طبقه","طفل","طقم","طويل","طويلة","طين","عاء","عادي","عربه","عرض","عسل","عصا","عصير","عطر","عقد","علبه","علي","عمان","عموم","غارنييه","غاز","غسل","غسول","غطاء","غلاية","غولفار","غير","فاتيكا","فراغ","فرشاه","فرك","فرن","فريش","فرينر","فستان","فلامنغو","فوستر","في","قارورة","قالب","قباله","قصير","قصيرة","قطع","قطعتين","قطعه","قفازات","قفل","قلم","قميص","قناع","قوس","كاب","كابري","كابل","كادريس","كار","كاس","كامل","كاندي","كبير","كبيره","كتاب","كتر","كرسي","كره","كريم","كعب","كعكه","كغ","كلاسيك","كليب","كوب","كوك","كوكتيل","كونكورد","كيت","كيس","كيك","لا","لايت","لايف","لتر","لحم","لعبه","لفه","للأطفال","للأولاد","للبنات","للجسم","للرجال","للسيدات","لوحه","لوشن","لوكس","لون","لونجي","ليبتون","ليمون","لينه","ماء","ماجيك","ماسالا","ماكس","ماكسي","ماكينة","مانجو","متعددة","مجانا","مجلس","مجموعة","مجموعه","محفظه","مخلل","مدرسيه","مراه","مربع","مروحة","مزدوجة","مزيج","مزيل","مستحضرات","مستديرة","مسحوق","مسمار","مشروب","مصباح","مصفاه","مضخة","مطهر","مع","معجون","معطف","مفتاح","مفك","مقبض","مقص","مقلاه","مقياس","مكرونة","مكنسة","مل","ملابس","ملاحظه","ملعقة","ملف","ملكي","ممحاة","ممسحة","من","مناديل","منشفه","منظف","موزع","موقد","مياه","ميد","ميكس","ميني","نبيل","نستله","نموذج","نيفيا","هديه","هلام","هوك","هيمالايا","واضح","ورقه","وساده","وشاح","وعاء","ووكر","وير","ويفر","يتوهم","يد","يغطي","يمكن","يوغوسلافيا"]

      }),

    watch: {
    scrcount: function(newValue, oldValue) {
     console.log(newValue+" "+oldValue)
    
     this.searchItem2();
    }
    },

    mounted() {
      // this.key = JSON.parse(localStorage.getItem("key"));
      // this.key = localStorage.getItem("key");
      //  this.keydata = localStorage.getItem("key");
     console.log("okk"+this.key)
   
    this.imgURL = localStorage.getItem("imgUrl");

     this.test = JSON.parse(localStorage.getItem("cartlist"));
     this.decimalPlaces=localStorage.getItem("decimalPlaces");
    
    
    //  this.getcategories();
     this.getPrimaryCurrency();
    //  this.getKeywords();
     this.scrollbody();
     this.getcategories();

    this.$parent.$children[0].$parent.$parent.itemcountnumber = localStorage.getItem('countitemno');
    
    
    },
    methods: {

      getKeywords: function () {
      axios.get(this.$bURL+"common/GetSearchKeywords")
      .then((response)  =>  {
        console.log(response.data)
        this.keyword = response.data
        // this.key = response.data
       
      }, (error)  =>  {
          console.log(error)
      })
    },
      //-----------------------------

        formatPrice(value) {
        const val = (value/1).toFixed(  this.decimalPlaces);
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
      setAltImg(bar) { 
        
          this.urlimg = "url("+this.imgURL+"ItemImage.jpg)";
       console.log("aa "+this.urlimg)
         document.getElementById(bar).style.backgroundImage = this.urlimg
         document.getElementById(bar).style.backgroundPosition = "center center";
          document.getElementById(bar).style.backgroundSize = "cover"
       
     }, 
     

      setcartcolor: function(){
           if(localStorage.getItem("carclicked")!== null)
    {
      
      this.loopcart = JSON.parse(localStorage.getItem("carclicked"));
      

      for(this.i=0;this.i<this.loopcart.length; this.i++)
        {

          console.log("ok"+this.loopcart[this.i])
          
          this.var = this.loopcart[this.i]

          document.getElementById(this.loopcart[this.i]).style.color = '#009900';
            
          
        
        }
    }
     if(localStorage.getItem("wishclicked")!== null)
     {
         this.loopwish = JSON.parse(localStorage.getItem("wishclicked"));
      

        for(this.i=0;this.i<this.loopwish.length; this.i++)
        {
          
          this.var = this.loopwish[this.i]
          document.getElementById(this.loopwish[this.i]).style.color = 'red';
           
        }
     
    }
      },
        getcategories: function ()      {

      axios.get(this.$bURL+"item/GetItemCategories")
      .then((response)  =>  {
        // this.loading = false;
        // this.categories = response.data;
          
      }, (error)  =>  {
          console.log(error)
      })

     },

      openitem : function(brcd,item)
      {
          
          Router.push('/singleitem');
          localStorage.setItem("barcode", brcd);
           localStorage.setItem("singleviewfullitem", JSON.stringify(item));
         
      },
      scrollbody()
      {
    window.onscroll = () => {
      
     if (Math.round(document.documentElement.scrollTop + window.innerHeight) == document.documentElement.offsetHeight) {
        this.scrcount +=1;
      }
    };



    
      },
      //------------------------------------------
 getPrimaryCurrency: function () {
      axios.get(this.$bURL+"Currency/GetPrimaryCurrency")
      .then((response)  =>  {
       // console.log(response.data)
        localStorage.setItem('decimalPlaces', response.data.DecimalPlaces);
        setTimeout(() => {
                  this.isLoading = false
         },1000)
      }, (error)  =>  {
          console.log(error)
      })
    },

///-----------------------------
  
    
     
//get item by scroll count

    searchItem: function () {
     
      //  this.searchword = this.search
       
      //    this.result = this.searchword.join();
     
      //    this.aaq = String(this.result).replace(/,/g, " ");
        //  console.log(this.aaq)
        this.isLoading = true;
      axios.get(this.$bURL+"item/GetItemSearchList?Keyword="+this.search+"&PageNumber="+this.scrcount)
      
      .then((response)  =>  {
        // this.loading = false;
        //console.log(response.data)
        this.scrollproducts = response.data;
        setTimeout(this.setcartcolor, 1000)
        setTimeout(() => {
          this.hidegif = false
                  this.isLoading = false
                  
         },4000)
      }, (error)  =>  {
          console.log(error)
      })
    },

    //-----------------------
    searchItem2: function () {
     
       this.searchword = this.search
         console.log(this.searchword)
        this.isLoading = true;
      axios.get(this.$bURL+"item/GetItemSearchList?Keyword="+this.searchword+"&PageNumber="+this.scrcount)
      
      .then((response)  =>  {
        // this.loading = false;
        //console.log(response.data)
        this.scrollproducts = this.scrollproducts.concat(response.data);
        setTimeout(this.setcartcolor, 1000)
        setTimeout(() => {
          this.hidegif = false
                  this.isLoading = false
                  
         },4000)
      }, (error)  =>  {
          console.log(error)
      })
    },


//--------------------------------------

   //cart Adding Function
   adcart: function (name,pos,bar,arb) {

     if (localStorage.getItem("carclicked") === null) {
  
      this.clicked.push(bar+arb)
     localStorage.setItem("carclicked",JSON.stringify(this.clicked))
       }else{
            this.clicked = JSON.parse(localStorage.getItem("carclicked"))
         this.clicked.push(bar+arb)
          localStorage.setItem("carclicked",JSON.stringify(this.clicked))
       
       }


     
     console.log("id "+ name+" pos "+pos)
      document.getElementById(bar+arb).style.color = '#009900';
    // if(this.cartlist.includes(this.scrollproducts[pos])) {
          //  document.getElementById("6950086683397").style.color = '#009900';
    //       alert("already there");
          
    //     }else{
      this.cart =JSON.parse(localStorage.getItem("cartlist"))
      if(this.cart!=null || this.cart!=undefined)
      {
            this.cartlist = this.cart;
      }
            
         this.flag=false; 
          this.flagid='';
       if(this.cartlist!=null || this.cartlist!=undefined)
       {
          for(this.i=0;this.i<this.cartlist.length;this.i++)
           {
             if( this.cartlist[this.i].Barcode===this.scrollproducts[pos].Barcode)
             {
               this.flag=true; 
               this.flagid=this.i; 
               break;
             }
           }
           if(this.flag===true)
           {
             console.log(this.cartlist[this.flagid].count);
             this.cartlist[this.flagid].count+=1
           }
           else{
             this.scrollproducts[pos].count=1;
             this.cartlist.push(this.scrollproducts[pos]);
           }
       }
      else {
          this.cartlist.push(this.scrollproducts[pos]);
       }
    
      // this.cartlist.push(this.scrollproducts[pos]);
          this.cartitem = this.cartlist;
           this.$parent.$children[0].$parent.$parent.addedcartitem = this.cartlist;
        localStorage.setItem("cartlistarray",JSON.stringify(this.cartlist))
        localStorage.setItem("cartcount",this.cartlist.length)
         this.$parent.$children[0].$parent.$parent.itemcountnumber = this.cartlist.length;
        localStorage.setItem("cartlist", JSON.stringify(this.cartlist));

        this.snackbar = {
                        message: 'Item Added Successfully',
                        color: 'success',
                        show: true
                    }
        // }
      

     
   
    },
    //wishlist adding function
     addwishlist: function (name,pos,bar) {



       if (localStorage.getItem("wishclicked") === null) {
  
        this.wishclicked.push(bar+name)
       localStorage.setItem("wishclicked",JSON.stringify(this.wishclicked))
    
       }else{
            this.wishclicked = JSON.parse(localStorage.getItem("wishclicked"))
          this.wishclicked.push(bar+name)
       localStorage.setItem("wishclicked",JSON.stringify(this.wishclicked))
       
       }


    
     console.log("id "+ name+" pos "+pos)
     
     document.getElementById(bar+name).style.color = 'red';
    
    // if(this.cartlist.includes(this.scrollproducts[pos])) {
          
    //       alert("already there");
          
    //     }else{
      this.wish =JSON.parse(localStorage.getItem("wishlist"))
      if(this.wish!=null || this.wish!=undefined)
      {
            this.wishlist = this.wish;
      }
            
         this.flag=false; 
          this.flagid='';
       if(this.wishlist!=null || this.wishlist!=undefined)
       {
          for(this.i=0;this.i<this.wishlist.length;this.i++)
           {
             if( this.wishlist[this.i].Barcode===this.scrollproducts[pos].Barcode)
             {
               this.flag=true; 
               this.flagid=this.i; 
               break;
             }
           }
           if(this.flag===true)
           {
             console.log(this.wishlist[this.flagid].count);
             this.wishlist[this.flagid].count+=1
           }
           else{
             this.scrollproducts[pos].count=1;
             this.wishlist.push(this.scrollproducts[pos]);
           }
       }
      else {
          this.wishlist.push(this.scrollproducts[pos]);
       }
    
      // this.cartlist.push(this.scrollproducts[pos]);
          this.wishitem = this.wishlist;
          //  this.$parent.$children[0].$parent.$parent.addedwishitem = this.wishlist;
        // localStorage.setItem("wishlistarray",JSON.stringify(this.wishlist))
        // localStorage.setItem("wishcount",this.wishlist.length)
        //  this.$parent.$children[0].$parent.$parent.itemcountnumber = this.wishlist.length;
        localStorage.setItem("wishlist", JSON.stringify(this.wishlist));

        // this.snackbar = {
        //                 message: 'Item is added to My Wishlist',
        //                 color: 'success',
        //                 show: true
        //             }
        // }
      

     
   
    },
    
  
  
  
    }
    


}
</script>
<style scoped>
.v-card__title {
    align-items: center;
    display: block ;
}
.cs{
  padding-left: 5px;
  padding-right: 5px;
   display: inline-block;
    width: 100%;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis; 
}
.v-snack__wrapper {
    align-items: center;
    background-color: #28a745 !important;
    border-radius: 25px;
}
.v-snack .v-snack--active{
 background-color: #28a745 !important;
}
.snackbar{
  background-color:black;
}
</style>